import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.array.find";
import Modal from '@/components/base/Modal/Modal.vue';

// client js begin
import util from '@tencent/vft-common/util';
import { markRead } from '@/services/magicService';
// client js end

var GiftType = {
  Gift: 1,
  // 弹窗礼包类型
  Wording: 2 // 在专属福利标题下方的图标文字类型(wording类型)
};

var cacheTimeKey = 'lastWelfare2019GiftModalTime';
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      giftShow: false
    };
  },
  components: {
    Modal: Modal
  },
  computed: {
    gift: function gift() {
      return this.data.data.vActList.find(function (item) {
        return item.tActType.iGiftType === GiftType.Gift;
      });
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var duration, lastTimestamp;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.gift) {
                duration = 24 * 60 * 60 * 1000; // 二十四小时内只显示一次
                if (util.getUrlParam('env') === 'test' && util.getUrlParam('gift_modal_duration')) {
                  duration = parseInt(util.getUrlParam('gift_modal_duration')) * 1000;
                }
                lastTimestamp = util.getUserCache(cacheTimeKey) || 0;
                if (Date.now() - lastTimestamp > duration) {
                  util.setUserCache(cacheTimeKey, Date.now());
                  // 上报一下，以保证每个actId只显示一次
                  markRead(this.gift.sActID);
                  this.giftShow = true;
                }
                if (util.getUrlParam('_giftShow') === '1') {
                  this.giftShow = true;
                }
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    closeGiftModal: function closeGiftModal() {
      this.giftShow = false;
    },
    clickGift: function clickGift(event) {
      event.stopPropagation();
      if (this.gift.tActType.sActType !== 'welfare') {
        this.openUrl(this.gift.tActType.sH5Url);
      }
    }
  },
  reportData: {
    '礼包弹窗': {
      'f_module': '专属福利',
      'f_resource': '礼包弹窗',
      'f_type': 5
    }
  }
};